import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=05dfb109&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"
import style0 from "./VButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports